import { render, staticRenderFns } from "./cell.vue?vue&type=template&id=d60fe1e6&scoped=true&"
import script from "./cell.vue?vue&type=script&lang=js&"
export * from "./cell.vue?vue&type=script&lang=js&"
import style0 from "./cell.vue?vue&type=style&index=0&id=d60fe1e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60fe1e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d60fe1e6')) {
      api.createRecord('d60fe1e6', component.options)
    } else {
      api.reload('d60fe1e6', component.options)
    }
    module.hot.accept("./cell.vue?vue&type=template&id=d60fe1e6&scoped=true&", function () {
      api.rerender('d60fe1e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/positions/data-table/cell.vue"
export default component.exports